var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navigation'),_c('div',{staticClass:"section bg-primary-3"},[_c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Fill In The Blank")]),_c('div',{staticClass:"text-large"},[_vm._v("I love "+_vm._s(_vm.CompanyName)+" because _________.")])])]),_c('Posts',{attrs:{"Category":"fill-in-the-blank"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }